import type {
  GameQuizKind,
  GameWithTags,
} from "../../../services/gameQuiz/gameQuiz.types";
import type { UploadCheck } from "../../../pages/App/HubSubida/hubTypes";

export interface ExamCourse {
  id: number;
  title: string;
  trimesterEvaluation: boolean;
  evaluatedCourseIds: number[];
  quizzes: { gameQuizId: number; quizKind?: GameQuizKind }[];
}

export const examCourseFromCheck = (check: UploadCheck): ExamCourse => ({
  id: check.courseId,
  title: check.title,
  trimesterEvaluation: check.trimesterEvaluation ?? false,
  evaluatedCourseIds: check.evaluatedCourseIds ?? [],
  quizzes: check.quizzes,
});

const label = ({ id, title }: ExamCourse): string => `#${id} — ${title}`;

const evaluatedList = (ids: number[]): string =>
  ids.length === 0
    ? "no tiene cursos evaluados"
    : `cursos ${[...ids].sort((a, b) => a - b).join(", ")}`;

export function examCourseErrors(
  course: ExamCourse,
  games: GameWithTags[],
): string[] {
  if (!course.trimesterEvaluation) {
    return [
      `El curso ${label(course)} no es una evaluación trimestral: un examen solo se puede asignar a una evaluación trimestral.`,
    ];
  }
  const normalQuiz = course.quizzes.find(
    ({ quizKind }) => (quizKind ?? "NORMAL") !== "EXAM",
  );
  if (normalQuiz) {
    return [
      `El curso ${label(course)} ya tiene un quiz normal (quiz ${normalQuiz.gameQuizId}): no se puede sustituir por un examen. Elimínalo primero.`,
    ];
  }
  const evaluated = new Set(course.evaluatedCourseIds);
  return games.flatMap((game, index) =>
    game.course_id !== undefined &&
    game.course_id !== null &&
    !evaluated.has(game.course_id)
      ? [
          `Pregunta ${index + 1}: el curso ${game.course_id} no es uno de los cursos que evalúa ${label(course)} (${evaluatedList(course.evaluatedCourseIds)}).`,
        ]
      : [],
  );
}
